<template>
  <svg width="19"
       height="20"
       viewBox="0 0 19 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66667 11.6665C3.10869 11.6665 3.53262 11.4909 3.84518 11.1783C4.15774 10.8658 4.33333 10.4419 4.33333 9.99984C4.33333 9.55781 4.15774 9.13389 3.84518 8.82133C3.53262 8.50877 3.10869 8.33317 2.66667 8.33317C2.22464 8.33317 1.80072 8.50877 1.48816 8.82133C1.17559 9.13389 1 9.55781 1 9.99984C1 10.4419 1.17559 10.8658 1.48816 11.1783C1.80072 11.4909 2.22464 11.6665 2.66667 11.6665ZM16.8333 3.33317C17.0543 3.33317 17.2663 3.24537 17.4226 3.08909C17.5789 2.93281 17.6667 2.72085 17.6667 2.49984C17.6667 2.27882 17.5789 2.06686 17.4226 1.91058C17.2663 1.7543 17.0543 1.6665 16.8333 1.6665C16.6123 1.6665 16.4004 1.7543 16.2441 1.91058C16.0878 2.06686 16 2.27882 16 2.49984C16 2.72085 16.0878 2.93281 16.2441 3.08909C16.4004 3.24537 16.6123 3.33317 16.8333 3.33317ZM16.8333 10.8332C17.0543 10.8332 17.2663 10.7454 17.4226 10.5891C17.5789 10.4328 17.6667 10.2209 17.6667 9.99984C17.6667 9.77882 17.5789 9.56686 17.4226 9.41058C17.2663 9.2543 17.0543 9.1665 16.8333 9.1665C16.6123 9.1665 16.4004 9.2543 16.2441 9.41058C16.0878 9.56686 16 9.77882 16 9.99984C16 10.2209 16.0878 10.4328 16.2441 10.5891C16.4004 10.7454 16.6123 10.8332 16.8333 10.8332ZM16.8333 18.3332C17.0543 18.3332 17.2663 18.2454 17.4226 18.0891C17.5789 17.9328 17.6667 17.7209 17.6667 17.4998C17.6667 17.2788 17.5789 17.0669 17.4226 16.9106C17.2663 16.7543 17.0543 16.6665 16.8333 16.6665C16.6123 16.6665 16.4004 16.7543 16.2441 16.9106C16.0878 17.0669 16 17.2788 16 17.4998C16 17.7209 16.0878 17.9328 16.2441 18.0891C16.4004 18.2454 16.6123 18.3332 16.8333 18.3332Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linejoin="round" />
    <path
      d="M12.6673 2.5H7.66732V17.5H12.6673M4.33398 10H12.6673"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#2DA7D7"
    }
  }
}
</script>
